/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.16",
    versionName: "0.2.0-nightly.2025.10.16",
    versionChannel: "nightly",
    buildDate: "2025-10-16T00:07:30.130Z",
    commitHash: "9819cae83ea653e96e6bbd24ffc1ca23bf7baef1",
};
